var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "patrol-form" } },
    [
      _c(
        "Titlebar",
        { attrs: { incrustation: "fa-history", backPath: "/patrols/list" } },
        [_c("h1", [_vm._v(_vm._s(_vm.pageTitle))])]
      ),
      _vm._v(" "),
      _vm.patrol
        ? _c("div", { staticClass: "container-fluid full-height" }, [
            _c(
              "div",
              { staticClass: "row justify-content-center full-height" },
              [
                _c(
                  "div",
                  { staticClass: "col-6 col-xl-5" },
                  [
                    _c("UiCard", [
                      _c("form", { staticClass: "form p-0" }, [
                        _c("div", { staticClass: "form-row row" }, [
                          _c("label", { staticClass: "col-4" }, [
                            _vm._v(_vm._s(_vm.$t("patrol.form.label"))),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-8" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.patrol.name,
                                  expression: "patrol.name",
                                },
                                { name: "validate", rawName: "v-validate" },
                              ],
                              staticClass: "form-input col",
                              attrs: {
                                type: "text",
                                name: "name",
                                "data-vv-rules": "required",
                                "data-vv-as": _vm.$t("patrol.form.label"),
                              },
                              domProps: { value: _vm.patrol.name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.patrol,
                                    "name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.showErrors["name"] &&
                                      _vm.errors.has("name"),
                                    expression:
                                      "showErrors['name'] && errors.has('name')",
                                  },
                                ],
                                staticClass: "form-input-error",
                                on: {
                                  click: function ($event) {
                                    return _vm.hideError("name")
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.errors.first("name")))]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row row" }, [
                          _c("label", { staticClass: "col-4" }, [
                            _vm._v(_vm._s(_vm.$t("patrol.form.description"))),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-8" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.patrol.description,
                                  expression: "patrol.description",
                                },
                                { name: "validate", rawName: "v-validate" },
                              ],
                              staticClass: "form-input col",
                              attrs: {
                                name: "description",
                                "data-vv-rules": "max:255",
                                "data-vv-as": _vm.$t("patrol.form.label"),
                              },
                              domProps: { value: _vm.patrol.description },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.patrol,
                                    "description",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.showErrors["description"] &&
                                    _vm.errors.has("description"),
                                  expression:
                                    "showErrors['description'] && errors.has('description')",
                                },
                              ],
                              staticClass: "form-input-error",
                              on: {
                                click: function ($event) {
                                  return _vm.hideError("description")
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.errors.first("description")))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row row" }, [
                          _c("label", { staticClass: "col-4" }, [
                            _vm._v(
                              _vm._s(_vm.$t("patrol.form.manageTravelTime"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col col-no-padding" },
                            [
                              _c("UiSwitch", {
                                model: {
                                  value: _vm.patrol.manageTravelTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.patrol,
                                      "manageTravelTime",
                                      $$v
                                    )
                                  },
                                  expression: "patrol.manageTravelTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.patrol.manageTravelTime,
                                expression: "patrol.manageTravelTime",
                              },
                            ],
                            staticClass: "form-row row",
                          },
                          [
                            _c("label", { staticClass: "col-4" }, [
                              _vm._v(
                                _vm._s(_vm.$t("patrol.form.theoricStartAt"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col col-no-padding" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "inputmask",
                                    rawName: "v-inputmask",
                                    value: "99:99",
                                    expression: "'99:99'",
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model.lazy",
                                    value: _vm.patrol.theoricStartAt,
                                    expression: "patrol.theoricStartAt",
                                    modifiers: { lazy: true },
                                  },
                                ],
                                staticClass: "form-input clock-picker-handler",
                                attrs: { type: "text" },
                                domProps: { value: _vm.patrol.theoricStartAt },
                                on: {
                                  blur: _vm.handleChangeStartAt,
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.patrol,
                                      "theoricStartAt",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row row" }, [
                          _c("label", { staticClass: "col-4" }, [
                            _vm._v(_vm._s(_vm.$t("patrol.form.profile"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-8" },
                            [
                              _c("multiselect", {
                                staticClass: "from-top",
                                attrs: {
                                  id: "patrolProfiles",
                                  multiple: true,
                                  "close-on-select": true,
                                  taggable: false,
                                  placeholder: "",
                                  options: _vm.profiles,
                                  label: "label",
                                  "track-by": "profileId",
                                },
                                on: {
                                  blur: _vm.modification,
                                  tag: _vm.modification,
                                  select: _vm.modification,
                                  remove: _vm.modification,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (ref) {
                                        var option = ref.option
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-inline-flex align-items-center text-truncate",
                                            },
                                            [
                                              option.meta.icon
                                                ? _c("ProfileIcon", {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      icon: option.meta.icon,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(option.label)),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "tag",
                                      fn: function (ref) {
                                        var option = ref.option
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-inline-flex align-items-center text-truncate",
                                            },
                                            [
                                              option.meta.icon
                                                ? _c("ProfileIcon", {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      icon: option.meta.icon,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(option.label)),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3755007992
                                ),
                                model: {
                                  value: _vm.patrolProfiles,
                                  callback: function ($$v) {
                                    _vm.patrolProfiles = $$v
                                  },
                                  expression: "patrolProfiles",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "form-text text-muted" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("patrol.form.profileHelp"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row row" }, [
                          _c("label", { staticClass: "col-4" }, [
                            _vm._v(_vm._s(_vm.$t("patrol.form.group"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-8" },
                            [
                              _c("multiselect", {
                                staticClass: "from-top",
                                attrs: {
                                  id: "patrolGroups",
                                  multiple: true,
                                  "close-on-select": true,
                                  taggable: false,
                                  placeholder: "",
                                  options: _vm.groups,
                                  label: "label",
                                  "track-by": "id",
                                },
                                on: {
                                  blur: _vm.modification,
                                  tag: _vm.modification,
                                  select: _vm.modification,
                                  remove: _vm.modification,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (ref) {
                                        var option = ref.option
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(option.label)),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "tag",
                                      fn: function (ref) {
                                        var option = ref.option
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(option.label)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  613307416
                                ),
                                model: {
                                  value: _vm.patrolGroups,
                                  callback: function ($$v) {
                                    _vm.patrolGroups = $$v
                                  },
                                  expression: "patrolGroups",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "form-text text-muted" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("patrol.form.groupHelp"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row row" }, [
                          _c("label", { staticClass: "col-4" }, [
                            _vm._v(_vm._s(_vm.$t("patrol.form.dati"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-8" },
                            [
                              _c("multiselect", {
                                staticClass: "from-top",
                                attrs: {
                                  id: "patrolDatis",
                                  multiple: true,
                                  "close-on-select": true,
                                  taggable: false,
                                  placeholder: "",
                                  options: _vm.datis,
                                  label: "label",
                                  "track-by": "id",
                                },
                                on: {
                                  blur: _vm.modification,
                                  tag: _vm.modification,
                                  select: _vm.modification,
                                  remove: _vm.modification,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (ref) {
                                        var option = ref.option
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(option.label)),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "tag",
                                      fn: function (ref) {
                                        var option = ref.option
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "tag-content" },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    option.label || option.name
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          option.from
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "tooltip bottom",
                                                    staticStyle: {
                                                      width: "140px",
                                                      bottom:
                                                        "calc(100% + 5px)",
                                                      right: "calc(50% - 14px)",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          option.fromObject
                                                            .name ||
                                                            option.fromObject
                                                              .label
                                                        ) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1207335855
                                ),
                                model: {
                                  value: _vm.patrolDatis,
                                  callback: function ($$v) {
                                    _vm.patrolDatis = $$v
                                  },
                                  expression: "patrolDatis",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "form-text text-muted" },
                                [_vm._v(_vm._s(_vm.$t("patrol.form.datiHelp")))]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-6 col-xl-7" },
                  [
                    _c(
                      "UiCard",
                      [
                        _vm.patrol.checkpoints &&
                        _vm.patrol.checkpoints.length > 0
                          ? _c(
                              "draggable",
                              {
                                attrs: {
                                  list: _vm.patrol.checkpoints,
                                  element: "div",
                                  options: _vm.draggableOptions,
                                },
                                on: { end: _vm.handleEnd },
                              },
                              _vm._l(
                                _vm.patrol.checkpoints,
                                function (checkpoint, key) {
                                  return _c("Checkpoint", {
                                    key: key,
                                    attrs: {
                                      checkpoint: checkpoint,
                                      number: key,
                                      manageTravelTime:
                                        _vm.patrol.manageTravelTime,
                                      theoricStartAt: _vm.patrol.theoricStartAt,
                                    },
                                    on: {
                                      editCheckpoint: _vm.handleEditCheckpoint,
                                      deleteCheckpoint:
                                        _vm.handleDeleteCheckpoint,
                                      modifCheckpointSinceLast:
                                        _vm.handleModifCheckpointSinceLast,
                                      modifCheckpointHourSinceStart:
                                        _vm.handleModifCheckpointHourSinceStart,
                                    },
                                  })
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "checkpoint checkpoint-add" },
                          [
                            _c("div", { staticClass: "col-left" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-center",
                                on: { click: _vm.openModalAddAP },
                              },
                              [
                                _c("div", { staticClass: "number" }, [
                                  _c("i", { staticClass: "fa fa-plus" }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "description" }, [
                                  _c("span", { staticClass: "button-add" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$t("patrol.btns.addCheckpoint")
                                        ) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-right" }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !!_vm.patrolError
                      ? _c("div", {
                          staticClass: "patrol-error",
                          domProps: {
                            innerHTML: _vm._s(_vm.timelineErrorMessage),
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Toolbar",
        { staticClass: "justify-content-end" },
        [
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-edit-patrols",
                  expression: "'beepiz-edit-patrols'",
                },
              ],
              staticClass: "primary",
              class: [{ disabled: _vm.patrolError }],
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.validForm()
                },
              },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("global.save")) + "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "Btn",
            [
              _c(
                "router-link",
                { attrs: { to: "/patrols/list", tag: "span" } },
                [_vm._v(_vm._s(_vm.$t("global.cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "modalAddAP",
          staticClass: "ActionPointsModal",
          attrs: { width: _vm.modalApWidth, height: "100%" },
        },
        [
          _c("span", {
            attrs: { slot: "header" },
            domProps: {
              innerHTML: _vm._s(_vm.$t("ap.titles.add.ap") + " PATROL"),
            },
            slot: "header",
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "full-height scroll",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("Library", {
                ref: "library",
                attrs: { chrome: false, patrol: true },
                on: {
                  selectAP: _vm.handleSelectAp,
                  cancelAP: _vm.handleCancelAp,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }